const items = [
  "Bodas",
  "Quinceaños",
  "Celebraciones familiares",
  "Eventos empresariales",
  "Confirmaciones",
  "Pases",
  "Mesas",
  "Un solo enlace",
];

export const Marquee = () => (
  <div data-testid="editorial-marquee" className="overflow-hidden border-y border-slate-200/80 bg-white py-5" aria-hidden="true">
    <div className="marquee-track flex w-max items-center gap-10">
      {[...items, ...items].map((item, i) => (
        <span key={i} className="flex items-center gap-10">
          <span
            className="whitespace-nowrap text-sm font-medium uppercase tracking-[0.25em] text-slate-400"
            style={{ fontFamily: "'Outfit', sans-serif" }}
          >
            {item}
          </span>
          <span className="h-1.5 w-1.5 rounded-full bg-indigo-300" />
        </span>
      ))}
    </div>
  </div>
);
